import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';

import ServiceBanner from '../sections/ServiceBanner/ServiceBanner';
import Symptoms from '../sections/Symptoms/Symptoms';
import Appointment from '../sections/Appointment/Appointment';
import DentalPlans from '../sections/DentalPlans/DentalPlans';

const Services = () => {
    return (
        <>
            <Navbar />
            <ServiceBanner />
            <DentalPlans />
            <Symptoms />
           
           
            <Footer />
        </>
    );
};

export default Services;